(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledAngucompleteAlt', {
            templateUrl: 'app/components/styled-angucomplete-alt/styled-angucomplete-alt.html',
            controller: StyledAngucompleteController,
            bindings: {
                labelKey: '@',
                name: '@',
                placeholder: '@',
                remoteUrl: '@',
                requestFormatter: '&',
                responseFormatter: '&',
                inputChanged: '&',
                selectedObject: '&',
                titleField: '@',
                pause: '@',
                descriptionField: '@',
                matchClass: '@',
                textNoResults: '@',
                textSearching: '@',
                clearSelected: '<',
                minLength: '<',
                inputClass: '@',
                required: '<',
                templateUrl: '@',
                isCustomized: '<',
                fromProducts: '<',
                onCreate: '&'
            }
        });

    /** @ngInject */
    function StyledAngucompleteController($scope) {
        var $ctrl = this;

        $scope.$on('createAction', function (event) {
            var typedValue = event.targetScope.searchStr || "";
            $ctrl.onCreate({ searchStr: typedValue });
        });
    }
})();
